@if (isDownlaoding$ | async) {
  <app-export-status [exportObject]="feed"></app-export-status>
}
<div class="feed">
  <div class="panes">
    @if (feed?.views?.includes("list")) {
      <div id="posts" class="pane pane-posts {{ paneClass }}">
        @if (feed?.is_paused) {
          <div class="feed-paused-banner" role="status">
            <fa-icon
              class="feed-paused-banner__icon"
              [icon]="['fas', 'pause-circle']"
            ></fa-icon>
            <div class="feed-paused-banner__text">
              <div class="feed-paused-banner__title">Updates paused</div>
              <div class="feed-paused-banner__message">
                @if (feed.timestamp_paused) {
                  No new posts have been added since
                  {{
                    feed.timestamp_paused * 1000
                      | date: NomDateTimeFormats.ANALYTICS_LONG
                  }}.
                } @else {
                  No new posts are being added to this feed.
                }
              </div>
            </div>
            <button
              type="button"
              class="feed-paused-banner__action"
              (click)="openFeedSettings()"
            >
              Open settings
            </button>
          </div>
        }
        <app-post-list
          #postList
          [posts]="posts$ | async"
          [loading]="postsLoading$ | async"
          [feed]="feed"
          [viewMode]="viewMode"
          [viewConfig]="feedViewConfig"
          [timeShown]="timeShown"
          [user]="user"
          [currentLanguage]="currentLanguage"
          [feedSearchQuery]="feedSearchQuery"
          [selectedPostId]="selectedPostId"
          [currentPage]="currentPage$ | async"
          [itemsPerPage]="itemsPerPage$ | async"
          [totalItemsCount]="totalItemsCount$ | async"
          [loadingAlgorithmPostIds]="loadingAlgorithmPostIds$ | async"
          [appliedAlgorithmPostIds]="appliedAlgorithmPostIds$ | async"
          [isStoryMode]="isStoryFeed"
          (togglePostDetails)="onTogglePostDetails($event.event, $event.index)"
          (requestToggleThread)="onRequestToggleThread($event)"
          (pageChanged)="onPageChanged($event)"
          (itemsPerPageChanged)="onItemsPerPageChanged($event)"
        >
          <app-feed-results-toolbar postListToolbar></app-feed-results-toolbar>
        </app-post-list>
      </div>
    }

    <!-- Second Pane -->
    @if (feed?.views?.includes("details")) {
      <div
        class="pane pane-details {{ paneClass }}"
        [class.pane-details--has-post]="selectedPostId$ | async"
      >
        <button
          type="button"
          class="pane-details__close"
          aria-label="Close details"
          (click)="closePostDetails()"
        >
          <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
        </button>
        @if (isStoryFeed) {
          <app-story-card-details
            [postId]="selectedPostId$ | async"
            [feedId]="feed.id"
            [viewConfig]="feedViewConfig"
          >
          </app-story-card-details>
        }
        @if (!isStoryFeed) {
          <app-post-card-details
            [postId]="selectedPostId$ | async"
            [feedId]="feed.id"
          >
          </app-post-card-details>
        }
      </div>
    }

    @if (feed?.views?.includes("analytics")) {
      <div id="widgets" class="pane pane-widgets {{ paneClass }}">
        <app-widget-toolbar
          (searchChange)="handleSearchStringWidgetChange($event)"
          (refresh)="widgetRefresh()"
          (configure)="widgetConfigure()"
          (selectAllChange)="selectAllWidgets($event)"
        ></app-widget-toolbar>
        @if (
          {
            selectedPlaceholderId: selectSelectedPlaceholderId$ | async,
            editMode: currentObjectEditMode$ | async,
            objectViewProperties: objectViewProperties$ | async,
            countSelectedWidgets: countSelectedWidgets$ | async,
          };
          as data
        ) {
          <div class="card-container widgets">
            @if (!widgetEditMode) {
              <gridstack
                [options]="gridstackOptions"
                (changeCB)="onGridChange($event)"
                (dragover)="onDragOver($event)"
                (drop)="onDrop($event)"
              >
                @if (widgetsLoading$ | async) {
                  <div class="app-loading-wrapper">
                    <app-loading-card
                      type="widget"
                      [count]="feed.count_widgets ? feed.count_widgets : 1"
                    ></app-loading-card>
                  </div>
                }
                <!-- options must be a reference-stable object (built in the component):
                a new reference makes gridstack-item call grid.update() on every
                change-detection cycle -->
                @for (
                  item of widgetsWithGridOptions$ | async;
                  track widgetTrackByFn($index, item)
                ) {
                  <gridstack-item [options]="item.gridOptions">
                    <app-widget-card
                      [widget]="item.widget"
                      [currentObject]="feed"
                      [user]="user"
                      [isPlaceholderSelected]="
                        item.widget.id === data.selectedPlaceholderId
                      "
                      [objectActionService]="objectActionService"
                      [editMode]="data.editMode"
                      [viewProperties]="data.objectViewProperties"
                      [resizingWidgetId$]="resizingWidgetId$"
                      [isDragging$]="isDragging$"
                      [searchString]="widgetSearchString"
                    ></app-widget-card>
                  </gridstack-item>
                }
              </gridstack>
            }
            @if (widgetEditMode) {
              <div
                class="widget-cardlist-container not-draggable"
                [appSortableList]="widgetsSortableList"
                [sortableDisabled]="
                  $safeNavigationMigration(widgetSearchString?.length) > 0
                "
                [dragThreshold]="5"
                [dragDelay]="150"
                [scrollSpeed]="50"
                [scrollSensitivity]="80"
                (sorted)="onWidgetListSorted($event)"
                (dragover)="onDragOver($event)"
                (drop)="onDrop($event)"
              >
                <!-- track MUST stay identity-based (`track widget`), matching the old
                *ngFor default. onWidgetListSorted cloneDeep's the list, so every item is
                a new reference and Angular rebuilds all rows - that full re-render is what
                resyncs the DOM after appSortableList has moved nodes itself. Tracking by
                id makes Angular move nodes instead, fighting the drag engine and breaking
                positions. The NG0956 re-creation warning here is expected. -->
                @for (widget of widgetsSortableList; track widget) {
                  <div class="widget-item">
                    @if (
                      widget.widget_type_id !==
                      WidgetType.WIDGET_TYPE_PLACEHOLDER
                    ) {
                      <app-widget-card-list
                        [widget]="widget"
                        [objectActionService]="objectActionService"
                        [searchString]="widgetSearchString"
                        (selectSectionBreak)="selectSectionBreakWidget($event)"
                      ></app-widget-card-list>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <!-- Sidebar -->
  <app-sidebar
    [buttons]="filteredSidebarButtons$ | async"
    [object]="feed$ | async"
    (componentSelected)="loadComponent($event)"
    #sidebar
  ></app-sidebar>
</div>
